import {Component} from 'react'
import { Container, Row } from 'reactstrap';
import CustomCard from '../../../components/common/customCard';
import NavTabMobile from '../../../components/common/global_layout/navtabMobile';
import NavTab from '../../../components/common/global_layout/navTab';
import HeadMobile from '../../../components/common/global_layout/carouselMobile';
import AdvancedSearchVoyage from '../../../components/common/Voyages/advancedSearchVoyage';

class Mondial_circuit extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return (
          <>
            <Container>
              <NavTab />
            </Container>

            <HeadMobile />

            <Container>
            <AdvancedSearchVoyage/>
              <NavTabMobile page="VOLS" width="100px" />
              <br />
              <div className="custom-card cards-Vol">
                <Row>
                  <CustomCard
                    IdSpe="hg-ctrl"
                    size={6}
                    imgPath={"/imgs/researchtypes/appartment.png"}
                    linkPath={"/voyages/1/details"}
                    title={"Dubai"}
                    subtitle={"70000 DZD"}
                  />
                  <CustomCard
                    IdSpe="hg-ctrl"
                    size={6}
                    imgPath={"/imgs/researchtypes/otdoors.png"}
                    linkPath={"/"}
                    title={"Turkey"}
                    subtitle={"70000 DZD"}
                  />
                </Row>
                <Row className="second-cards-Vol">
                  <CustomCard
                    IdSpe="hg-ctrl"
                    size={4}
                    imgPath={"/imgs/researchtypes/otdoors.png"}
                    linkPath={"/"}
                    title={"Maroc"}
                    subtitle={"70000 DZD"}
                  />{" "}
                  <CustomCard
                    IdSpe="hg-ctrl"
                    size={4}
                    imgPath={"/imgs/researchtypes/bungalo.png"}
                    linkPath={"/"}
                    title={"Jordan"}
                    subtitle={"70000 DZD"}
                  />{" "}
                  <CustomCard
                    IdSpe="hg-ctrl-disp"
                    size={4}
                    imgPath={"/imgs/researchtypes/appartment.png"}
                    linkPath={"/"}
                    title={"Chine"}
                    subtitle={"70000 DZD"}
                  />
                </Row>
              </div>
            </Container>
            <br /><br />
          </>
        );
    }
}
 
export default Mondial_circuit;